import SingleChoice from "../../components/singleChoice";
import { useWizard } from "react-use-wizard";
import NavigateBack from "../../components/navigateBack";
import stepMap from "./utils";

function SingleChoiceStep({
  qKey,
  question,
  choices,
  onSubmitHandler,
  state,
  prevWizardStep,
}) {
  const { previousStep, nextStep, goToStep } = useWizard();
  const _qKey = qKey;

  const onNextFn = (data) => {
    if (prevWizardStep) {
      onSubmitHandler({ [_qKey]: data }, true);
    } else {
      onSubmitHandler({ [_qKey]: data });
    }
    if (data.hasOwnProperty("next") && stepMap.hasOwnProperty(data["next"])) {
      console.log("Going to step " + stepMap[data["next"]].toString());
      goToStep(stepMap[data["next"]]);
    } else {
      nextStep();
    }
  };

  const goBack = () => {
    const ps = prevWizardStep();
    if (ps !== -1) {
      goToStep(ps);
    } else {
      // previousStep()
      goToStep(0);
    }
  };

  return (
    <>
      <NavigateBack onClickHandler={goBack} />
      <SingleChoice
        question={question}
        qKey={qKey}
        choices={choices}
        selectedChoice={state}
        onSubmitHandler={onNextFn}
      />
    </>
  );
}

export default SingleChoiceStep;
